import React from 'react';
import {observer} from "mobx-react-lite";
import intl from "react-intl-universal";
import {useMobileNavController, useRootStore} from "@stores/AppStateContext";

import {RightMenuName} from "@stores/RootStore";

import {ActiveUserCount} from "./elements/ActivUsers"
import {GroupIcon} from "../../components/icons/GroupIcon";
import {getRightMenuHeader} from "./RightMenuHeader";
import {MobileRightMenuHeader as MobileRightMenuHeaderView} from "../../components/MobileRightMenuHeader/MobileRightMenuHeader";

import {PAGES} from "@stores/ViewStore";

export const MobileRightMenuHeader = observer(() => {
    const rootStore = useRootStore();
    const mobileNav = useMobileNavController();
    let content;
    switch (rootStore.rightMenu) {
        case 'outline':
        case 'comments':
        case 'history':
        case 'acknowledgement':
            content = getRightMenuHeader(rootStore.rightMenu as RightMenuName);
            break;
        case 'activeUsers':
            content = (
                <div className="ActiveUsers-header">
                    <div className="ActiveUsers-title ">
                        {intl.get('activeUsers.header.mobile').d('Active users')}
                    </div>
                    <ActiveUserCount/>
                    <div className="ActiveUsersIcon">
                        <GroupIcon size={20}/>
                    </div>
                </div>
            )
            break;
        default:
            break;
    }
    return (
        <MobileRightMenuHeaderView
            content={content}
            onClose={(event) => {
                event.stopPropagation();
                rootStore.rightMenu === 'profile'
                    ? rootStore.view.openPageByName(PAGES.KNOWLEDGE_BASE)
                    : rootStore.view.openPageByName(PAGES.DOC_EDIT, rootStore.view.pathParams, {});
                rootStore.setRightMenu('');
                mobileNav.openPage();
            }}
        />
    );
})
